<p>
  <span *ngIf="isStudent">
      For installation on devices <strong>privately</strong> owned or leased by a student. Must be purchased with
      student personal funds. Subject to sales tax.
  </span>
  <span *ngIf="isEmployee">
      For installation on devices <strong>privately</strong> owned or leased by an employee. Must be purchased with
      employee personal funds. Subject to sales tax.
  </span>
  <span *ngIf="isUniversity">
      For installation on devices owned or leased by the university. Must be purchased with
      university funds. Exempt from sales tax.
  </span>
  <a [routerLink]="'./'" (click)="scrollToLicenseDetails()">See License Details.</a>
</p>
